<div class="modal-header sg-modal__header pb-0" [ngClass]="{'-secondary rounded-top': modService.configStore.headerStyle === 'secondary'}">

    <ng-content select="[header]"></ng-content>

    <button type="button" class="sg-modal__close" aria-label="Close" *ngIf="!modService.configStore.closeBtnRemove" (click)="modService.dismiss()">
        <mlp-ng-icon name="close"></mlp-ng-icon>
    </button>

</div>

<div class="modal-body">

    <ng-content select="[body]"></ng-content>

</div>

<div class="sg-modal__footer pt-0">

    <ng-content select="[footer]"></ng-content>

</div>

<div class="sg-modal__shard pt-0">

    <div class="-container">

        <ng-content select="[shard]"></ng-content>

    </div>

</div>

